import { Component, OnInit, NgZone, ViewChild, ElementRef } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { ChatService } from '@services/chat.service';
import { FriendService } from '@services/friend.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ViewService } from '@services/view.service';
import { SearchService } from '@services/search.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import * as _ from 'lodash';
@Component({
  selector: 'app-cchatlist',
  templateUrl: './cchatlist.component.html',
  styleUrls: ['./cchatlist.component.sass']
})
export class CchatlistComponent implements OnInit {
  component = '';
  pathToMedia: any = {};
  chat_refresh: any;
  application = 'chat'
  chatid = "";
  crefresh = false;
  mid = '';
  first = false;
  qparam: any = [];
  action_menu = false;
  upload_menu = false;
  member_response: any = [];
  chat_list: any = [];
  page_loading = true;
  user_id = '';
  comment = "";
  public pconfig: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true,
    dictDefaultMessage: "<i class='fa fa-photo'></i> Photo",
    maxFiles: 1
  };
  public aconfig: DropzoneConfigInterface = {
    acceptedFiles: '.mp3',
    clickable: true,
    dictDefaultMessage: "<i class='fa fa-volume-up'></i> Audio",
    maxFiles: 1
  };
  public vconfig: DropzoneConfigInterface = {
    acceptedFiles: '.mp4',
    clickable: true,
    dictDefaultMessage: "<i class='fa fa-video-camera'></i> Video",
    maxFiles: 1
  };
  constructor(public ngxSmartModalService: NgxSmartModalService, private _searchService: SearchService, private _friend: FriendService, private _viewService: ViewService, private _chat: ChatService, private fb: FormBuilder, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SMN;
    this.user_id = this._global.getSessionVal('id');
    this.route.queryParams.subscribe(params => {
      this.qparam = params;
      this.chatid = this.qparam['cid'];
      this.mid = this.qparam['id'];
      if (this.chatid) {
        let p = {
          component: this.component,
          application: this.application,
          id: this.chatid
        }
        let pa = {
          component: this.component,
          application: 'member',
          id: this.mid
        }
        this.loadMemberView(pa);
        this.loadChat(p);
      }
    });
  }

  ngOnInit(): void {
  }
  ngOnDestroy() {
    clearInterval(this.chat_refresh);
  }

  loadMemberView(p) {
    this._viewService.application(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.page_loading = false;
          this.member_response = this._global.getVal(data, 'response', {})
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  loadChat(p) {
    this._chat.list(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response.entries', {}))) {
          let a = [];
          a.push(this._global.getVal(data, 'response.entries', {}))
          this.chat_list = a;
          this.chatRefresh();
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  showActionMenu() {
    this.action_menu = true;
  }
  returnZero() {
    return 0
  }
  create() {
    let p = {
      component: this.component,
      application: this.application,
      comment: this.comment,
      pathToMedia: "{}",
      friendId: this.mid,
      id: this.chatid,
      metaData: "{}",
    }
    this._chat.create(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', {}))) {
          this.comment = '';
          // this.chat_list =  this.chat_list.concat(this._global.getVal(data, 'response.entries', {}));
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  public onUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'attachment', '');
  }
  public onUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public onUploadSuccess(args: any): void {
    this.pathToMedia = {};
    let res = JSON.parse(args[1]);
    if (this._global.getVal(res, 'id', '')) {
      res['entityType'] = 'photo';
      this.pathToMedia[res['id']] = this._global.getUploadPathToMedia(res);
      let metaData = {
        mediaId: this._global.getVal(res, 'id', ''),
        mediaType: 'photo'
      };
      let p = {
        component: this.component,
        application: this.application,
        comment: this.comment,
        pathToMedia: JSON.stringify(this.pathToMedia),
        friendId: this.mid,
        id: this.chatid,
        metaData: JSON.stringify(metaData)
      }
      this._chat.create(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response.entries', {}))) {
            // this.chat_list = this.chat_list.concat(this._global.getVal(data, 'response.entries', {}));
          }

        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    }
  }

  public onUploadAInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'attachment', '');
  }
  public onUploadAError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public onUploadASuccess(args: any): void {
    this.pathToMedia = {};
    let res = JSON.parse(args[1]);
    if (this._global.getVal(res, 'id', '')) {
      res['entityType'] = 'audio';
      this.pathToMedia[res['id']] = this._global.getUploadPathToMedia(res);
      let metaData = {
        mediaId: this._global.getVal(res, 'id', ''),
        mediaType: 'audio'
      };
      let p = {
        component: this.component,
        application: this.application,
        comment: this.comment,
        pathToMedia: JSON.stringify(this.pathToMedia),
        friendId: this.mid,
        id: this.chatid,
        metaData: JSON.stringify(metaData)
      }
      this._chat.create(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response.entries', {}))) {
            // this.chat_list = this.chat_list.concat(this._global.getVal(data, 'response.entries', {}));
          }

        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    }
  }

  public onUploadVInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'attachment', '');
  }
  public onUploadVError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public onUploadVSuccess(args: any): void {
    this.pathToMedia = {};
    let res = JSON.parse(args[1]);
    if (this._global.getVal(res, 'id', '')) {
      res['entityType'] = 'video';
      this.pathToMedia[res['id']] = this._global.getUploadPathToMedia(res);
      let metaData = {
        mediaId: this._global.getVal(res, 'id', ''),
        mediaType: 'video'
      };
      let p = {
        component: this.component,
        application: this.application,
        comment: this.comment,
        pathToMedia: JSON.stringify(this.pathToMedia),
        friendId: this.mid,
        id: this.chatid,
        metaData: JSON.stringify(metaData)
      }
      this._chat.create(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response.entries', {}))) {
            // this.chat_list = this.chat_list.concat(this._global.getVal(data, 'response.entries', {}));
          }

        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    }
  }
  getChatEntity(obj) {
    let entity = '';
    let path = obj['pathToMedia'];
    Object.entries(path).forEach(([key, value]) => {
      if (value) {
        entity = this._global.getVal(value, 'entityType', '');
      }
    });
    return entity
  }
  chatRefresh() {
    this.ngOnDestroy();
    this.crefresh = true; 
    if (this.crefresh) {
      this.crefresh = false;
      let p = {
        component: this.component,
        application: this.application,
        id: this.chatid
      }
      this._chat.list(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response.entries', {}))) {
            let a = [];
            a.push(this._global.getVal(data, 'response.entries', {}))
            this.chat_list = a;
            this.chat_refresh = setInterval(() => {
              this.chatRefresh();
              this.crefresh = true;
              this.ngOnDestroy();
            }, 15000);
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    }
  }
  gotoProfile(){
    let id=this.mid;
    if(this._global.isOwner(id)){
      this.router.navigate(['/my']);
    }else{
      this.router.navigate(['/view/member'], { queryParams: { 'id' : id } });
    }
  }
}
